import React from 'react';
import { DateInput } from 'framework/form';
import { useShowContext } from 'framework/show';

const TerminateAgreementForm = () => {
  const { data: agreement } = useShowContext();

  const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
  const agreementStartDate = agreement?.startDate;

  // Use the later of today or agreement start date as minimum date
  const minDate = agreementStartDate && agreementStartDate > today ? agreementStartDate : today;

  return (
    <>
      <DateInput label="Termination date" source="endDate" isRequired minDate={minDate} />
    </>
  );
};

export default TerminateAgreementForm;
